export const PIPELINE = [
  { id: "nouveau", label: "Nouveau", chip: "bg-purple-50 text-purple-700 border-purple-200" },
  { id: "a_contacter", label: "À contacter", chip: "bg-neutral-100 text-neutral-600 border-neutral-200" },
  { id: "contacte", label: "Contacté", chip: "bg-blue-50 text-blue-700 border-blue-200" },
  { id: "rdv_fixe", label: "RDV fixé", chip: "bg-green-50 text-green-700 border-green-200" },
  { id: "devis_envoye", label: "Devis envoyé", chip: "bg-amber-50 text-amber-700 border-amber-200" },
  { id: "a_relancer", label: "À relancer", chip: "bg-orange-50 text-orange-700 border-orange-200" },
  { id: "gagne", label: "Gagné", chip: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  { id: "perdu", label: "Perdu", chip: "bg-neutral-100 text-neutral-400 border-neutral-200" },
];
export const statusOf = (id) => PIPELINE.find((s) => s.id === id) || PIPELINE[0];
export const ACTIVE_IDS = ["nouveau", "a_contacter", "contacte", "rdv_fixe", "devis_envoye", "a_relancer"];
export const isActive = (p) => ACTIVE_IDS.includes(p.status);
export const isOverdue = (p) => isActive(p) && p.next_followup
  && p.next_followup <= new Date().toISOString().slice(0, 10);

export const SOURCES = [
  ["instagram", "Instagram"], ["facebook", "Facebook"], ["google", "Google"], ["site_web", "Site web"],
  ["recommandation", "Recommandation"], ["reseau", "Réseau"], ["prospection_directe", "Prospection directe"],
  ["ancien_client", "Ancien client"], ["autre", "Autre"],
];
export const sourceLabel = (id) => SOURCES.find(([k]) => k === id)?.[1] || id || "—";

export const LOSS_REASONS = [
  ["prix", "Prix"], ["pas_de_reponse", "Pas de réponse"], ["concurrent", "Concurrent"],
  ["projet_abandonne", "Projet abandonné"], ["mauvais_timing", "Mauvais timing"],
  ["besoin_non_adapte", "Besoin non adapté"], ["autre", "Autre"],
];
export const lossLabel = (id) => LOSS_REASONS.find(([k]) => k === id)?.[1] || id || "—";

export const ACTION_TYPES = [
  ["appel", "Appel"], ["email", "Email"], ["rdv", "RDV"], ["relance", "Relance"],
  ["devis", "Devis"], ["autre", "Autre"],
];
export const actionLabel = (id) => ACTION_TYPES.find(([k]) => k === id)?.[1] || id || "—";

export const frDate = (iso) => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : "—");
export const frDateTime = (iso) => (iso ? `${frDate(iso)} ${iso.slice(11, 16)}` : "—");

export const QUOTE_STATUS_LABELS = { brouillon: "Brouillon", envoye: "Envoyé", accepte: "Accepté", refuse: "Refusé", converti: "Converti" };
